export const FIREBASE_AUTH_SESSION_CONFIG = {
  cookieName: 'firebase-auth-session',
  cookieOptions: {
    httpOnly: true,
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
    maxAge: 60 * 60, // * Firebase auth id token 預設 1 hour 過期
    path: '/',
  },
} as const;

export const FIREBASE_AUTH_SUCCESS_MESSAGES = {
  activateSuccess: '帳戶啟用成功，請點選下方按鈕前往登入',
  resetPasswordSuccess: '密碼重置成功，請使用新密碼登入',
} as const;

export const FIREBASE_AUTH_ERROR_MESSAGES = {
  // * Sign In / Sign Up Errors
  'auth/email-already-in-use': 'Email 已經被註冊',
  'auth/invalid-email': 'Email 格式不正確',
  'auth/operation-not-allowed': '認證方式尚未在 firebase console 中啟用',
  'auth/weak-password': '密碼強度不足（通常至少需要 6 個字符）',
  'auth/user-disabled': '使用者帳號已被停用',
  'auth/user-not-found': '沒有此使用者',
  'auth/wrong-password': '密碼錯誤',
  'auth/invalid-credential': '帳號或密碼錯誤',
  // 'auth/invalid-verification-code': '簡訊驗證碼無效',
  // 'auth/invalid-verification-id': '簡訊驗證 ID 無效',
  // 'auth/missing-verification-code': '未提供簡訊驗證碼',
  // 'auth/missing-verification-id': '未提供簡訊驗證 ID',
  // 'auth/too-many-requests': '來自此裝置的請求次數過多，已被暫時封鎖',

  // * Account Management Errors
  'auth/requires-recent-login': '需要使用者重新登入才能執行敏感操作',
  'auth/email-already-exists': '更新使用者時，新的 email 已被使用',
  'auth/invalid-password': '密碼格式不正確',
  // 'auth/phone-number-already-exists': '該電話號碼已與其他帳號綁定',
  // 'auth/invalid-phone-number': '電話號碼格式不正確',

  // * Email Verification Errors
  'auth/expired-action-code': '驗證連結已過期',
  'auth/invalid-action-code': '驗證碼無效或已使用',
  'auth/user-not-verified': '使用者 email 尚未驗證',

  // * Token Errors
  'auth/id-token-expired': 'ID token 已過期',
  'auth/id-token-revoked': 'ID token 已被撤銷',
  'auth/invalid-id-token': '無效的 ID token',

  // * Other Authentication Errors
  'auth/internal-error': 'Firebase auth 伺服器遇到錯誤',
  'auth/invalid-api-key': '使用了無效的 Firebase API key',
  'auth/app-deleted': 'Firebase app 已被刪除',
  'auth/user-token-expired': '使用者 id token 過期，需要重新登入',
  'auth/web-storage-unsupported': '瀏覽器不支援 web storage 或已被禁用',
  'auth/network-request-failed': '網路連線失敗',
  'auth/popup-blocked': '彈窗被瀏覽器阻擋',
  'auth/popup-closed-by-user': '使用者關閉了彈窗',
  'auth/unauthorized-domain': '網域名未在 firebase console 中授權',
  'auth/quota-exceeded': 'Firebase 費用已超額',
} as const;
